import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";
import GenericPopup from "../../genericpopup";

type RequestItem = {
    id?: string;
    reqType: string;
    title: string;
    reqDate?: string;
    reqContent: string;
    status: string;
};

const ServiceRequest: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("All");
    const [showErrorPopup, setShowErrorPopup] = useState(false);

    const [requestItem, setRequestItem] = useState<RequestItem>({
        title: "",
        reqType: "",
        reqContent: "",
        status: "PENDING",
    });

    const [requestTypes, setRequestTypes] = useState<string[]>([
        "Pickup",
        "Drop",
        "Inward",
        "Outward",
        "Meet Teacher",
        "Other",
    ]);

    const [allRequests, setAllRequests] = useState<RequestItem[]>([]);
    const [filteredRequests, setFilteredRequests] = useState<RequestItem[]>([]);

    const filterButtons = ["All", ...requestTypes];

    const Requests = async () => {
        setIsLoading(true);
        try {
            const response = await serviceApi.get(environment.servicerequest);
            if (response?.status === "SUCCESS") {
                setAllRequests(response?.dataList || []);
                setFilteredRequests(response?.dataList || []);

                if (response?.dataList2?.length > 0) {
                    setRequestTypes(response.dataList2);
                }
            }
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        Requests();
    }, []);

    const setFilter = (filter: string) => {
        setSelectedFilter(filter);
        if (filter === "All") {
            setFilteredRequests(allRequests);
        } else {
            setFilteredRequests(
                allRequests.filter((req) => req.reqType === filter)
            );
        }
    };

    const saveRequest = async () => {
        if (!requestItem.reqType || !requestItem.title || !requestItem.reqContent) {
            setShowErrorPopup(true);
            return;
        }
        setIsLoading(true);
        try {
            const response = await serviceApi.post(
                environment.servicerequest,
                requestItem
            );
            if (response?.status === "SUCCESS") {
                setShowInput(false);

                setRequestItem({
                    title: "",
                    reqType: "",
                    reqContent: "",
                    status: "PENDING",
                });
                Requests();
            }
        } finally {
            setIsLoading(false);
        }
    };

    const getStatusBg = (status: string) => {
        const x = status.toLowerCase();
        if (x === "pending") return "var(--colorCustomDark)";
        if (x === "approved" || x === "completed") return "var(--colorPrimaryDark)";
        if (x === "rejected") return "var(--colorAccentDark)";
        return "var(--colorPrimaryDark)";
    };

    return (
        <div className="notification-page">
            {showErrorPopup && (
                <GenericPopup
                    isOpen={showErrorPopup}
                    title="Error"
                    message="Please fill all fields"
                    type="alert"
                    onClose={() => setShowErrorPopup(false)}
                />
            )}
            {isLoading && (
                <div className="loading-overlay">
                    <div className="loading-overlay__content">
                        <div className="spinner spinner--lg"></div>
                        <span className="loading-text">Loading service requests...</span>
                    </div>
                </div>
            )}
            <div className="notification-page">

                {/* PAGE TITLE (like Feedback heading) */}
                <h2
                    className="title-text notification-heading"
                    style={{
                        textAlign: "center",
                        marginBottom: "10px"
                    }}
                >
                    Service Request
                </h2>
                <div className="event-container" style={{ padding: "12px" }}>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontWeight: "bold",
                            alignItems: "center",
                        }}
                    >
                        <span style={{ color: "var(--colorPrimaryDark)", marginLeft: "14px" }}>
                            Create Service Request
                        </span>

                        {!showInput ? (
                            <i
                                className="fa-solid fa-plus"
                                onClick={() => setShowInput(true)}
                                style={{
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    color: "#e0544d",
                                    userSelect: "none",
                                }}
                            />
                        ) : (
                            <i
                                className="fa-solid fa-xmark"
                                onClick={() => setShowInput(false)}
                                style={{
                                    fontSize: "18px",
                                    cursor: "pointer",
                                    color: "#e0544d",
                                    userSelect: "none",
                                }}
                            />
                        )}
                    </div>
                    {showInput && (
                        <div style={{ marginTop: "12px", width: "100%" }}>
                            <select
                                value={requestItem.reqType}
                                onChange={(e) =>
                                    setRequestItem({ ...requestItem, reqType: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    outline: "none",
                                    boxSizing: "border-box",
                                }}
                            >
                                <option value="">Select Type</option>
                                {requestTypes.map((type, i) => (
                                    <option key={i} value={type}>
                                        {type}
                                    </option>
                                ))}
                            </select>
                            <input
                                placeholder="Subject"
                                value={requestItem.title}
                                onChange={(e) =>
                                    setRequestItem({ ...requestItem, title: e.target.value })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    marginBottom: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    outline: "none",
                                    boxSizing: "border-box",
                                }}
                            />
                            <textarea
                                rows={3}
                                placeholder="Description"
                                value={requestItem.reqContent}
                                onChange={(e) =>
                                    setRequestItem({
                                        ...requestItem,
                                        reqContent: e.target.value,
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    outline: "none",
                                    resize: "none",
                                    boxSizing: "border-box",
                                }}
                            />
                            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                <button
                                    onClick={saveRequest}
                                    style={{
                                        marginTop: "10px",
                                        background: "var(--colorPrimaryDark)",
                                        color: "#fff",
                                        border: "none",
                                        padding: "8px 16px",
                                        borderRadius: "6px",
                                        cursor: "pointer",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </div>
            <div className="filter-section">
                {filterButtons.map((f, i) => (
                    <button
                        key={i}
                        onClick={() => setFilter(f)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "20px",
                            border: "1px solid #ddd",
                            background:
                                selectedFilter === f
                                    ? "var(--colorPrimaryDark)"
                                    : "#fff",
                            color:
                                selectedFilter === f ? "#fff" : "var(--colorPrimaryDark)",
                            cursor: "pointer",
                        }}
                    >
                        {f}
                    </button>
                ))}
            </div>
            {filteredRequests.map((item, index) => (
                <div key={index} className="event-container">
                    {item.reqDate && (
                        <span
                            className="event-date"
                            style={{
                                color: "var(--colorPrimaryDark)",
                                fontWeight: 700,
                            }}
                        >
                            {item.reqDate}
                        </span>
                    )}
                    <div className="horizontal-divider" />
                    <div className="event-item">
                        <h4
                            className="event-title"
                            style={{ color: "var(--colorPrimaryDark)" }}
                        >
                            {item.title}
                        </h4>
                        <p className="event-description">{item.reqContent}</p>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <span>{item.reqType}</span>
                            <span
                                style={{
                                    background: getStatusBg(item.status),
                                    color: "#fff",
                                    padding: "4px 10px",
                                    borderRadius: "999px",
                                    fontSize: "12px",
                                }}
                            >
                                {item.status}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ServiceRequest;